import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';
import { FormField, Form } from '../../types/form';
import { isLogicOptions } from '../../types/guards';

interface LogicFieldEditorProps {
  field: FormField;
  form: Form;
  onFieldChange: (updates: Partial<FormField>) => void;
}

const LogicFieldEditor: React.FC<LogicFieldEditorProps> = ({ field, form, onFieldChange }) => {
  const getSourceFieldValue = () => {
    const availableFields = form.fields.filter(f => f.field_type === 'checkbox_with_input' && f.id !== field.id);
    
    if (!field.options || !isLogicOptions(field.options)) {
      return '';
    }
    
    const logicOptions = field.options;
    
    // First try to match by field ID
    let matchedField = availableFields.find(f => f.id === logicOptions.sourceFieldId);
    
    // If no match by ID, try to match by field label
    if (!matchedField && 'sourceFieldLabel' in logicOptions) {
      matchedField = availableFields.find(f => f.label === (logicOptions as any).sourceFieldLabel);
    }
    
    return matchedField ? matchedField.id : '';
  };

  const handleSourceFieldChange = (value: string) => {
    const selectedField = form.fields.find(f => f.id === value);
    if (selectedField) {
      onFieldChange({ 
        options: { 
          ...field.options, 
          sourceFieldId: value,
          sourceFieldLabel: selectedField.label
        }
      });
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor={`logicType-${field.id}`}>Logic Type</Label>
        <Select
          value={field.options && isLogicOptions(field.options) ? field.options.logicType : 'sum_checkbox_inputs'}
          onValueChange={(value) => onFieldChange({ 
            options: { ...field.options, logicType: value }
          })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select logic type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="sum_checkbox_inputs">Sum Checkbox Inputs</SelectItem>
            <SelectItem value="exam_duration_calculation">Exam Duration Calculation</SelectItem>
            <SelectItem value="custom">Custom Logic (Future)</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div>
        <Label htmlFor={`sourceField-${field.id}`}>Source Field</Label>
        <Select
          value={getSourceFieldValue()}
          onValueChange={handleSourceFieldChange}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select field to process" />
          </SelectTrigger>
          <SelectContent>
            {form.fields
              .filter(f => f.field_type === 'checkbox_with_input' && f.id !== field.id)
              .map(sourceField => (
                <SelectItem key={sourceField.id} value={sourceField.id}>
                  {sourceField.label}
                </SelectItem>
              ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default LogicFieldEditor;